<app-dialog
  [headerLabel]="'LABEL.EDIT_DISCOUNT' | translate"
  [primaryActionText]="'ACTION.SAVE' | translate"
  [secondaryActionText]="'ACTION.CANCEL' | translate"
  [dialogType]="dialogType"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="saveAction"
  [secondaryActionTapped]="cancelAction"
  (onPrimaryAction)="onSave()"
>
  <div id="document-discount-dialog">
    <app-form-master *ngIf="form" [form]="form" class="form-content">
      <p class="info-text">
        {{ 'DIALOG.DOCUMENT_DISCOUNT.INFO_TEXT' | translate }}
      </p>

      <div class="form-row">
        <app-currency-field
          [label]="'LABEL.DISCOUNT' | translate"
          fieldId="discount_amount_field"
          [hideLabel]="true"
          [currencyCode]="currencyCode"
          [locale]="locale"
          [formControl]="form.get(formKeys.DISCOUNT_AMOUNT)"
          [hidden]="
            form.get(formKeys.DISCOUNT_TYPE).value !== DiscountTypesEnum.amount
          "
        >
        </app-currency-field>

        <app-percentage-field
          [label]="'LABEL.DISCOUNT' | translate"
          fieldId="discount_percentage_field"
          [hideLabel]="true"
          [formControl]="form.get(formKeys.DISCOUNT_PERCENTAGE)"
          [locale]="locale"
          [hidden]="
            form.get(formKeys.DISCOUNT_TYPE).value !==
            DiscountTypesEnum.percentage
          "
        >
        </app-percentage-field>

        <div class="value-switch-field-wrapper">
          <app-value-switch-field
            fieldId="discount_value_switch_field"
            [switches]="discountSwitches"
            [formControl]="form.get(formKeys.DISCOUNT_TYPE)"
          >
          </app-value-switch-field>
        </div>
      </div>
    </app-form-master>
  </div>
</app-dialog>
